import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const previousOnboardingsValidationState = atom<boolean>({
  key: 'previousOnboardingsValidationState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
